<template>
  <div class="chart-container d-flex justify-center">
    <canvas id="doughnut-chart" height="175"></canvas>
  </div>
</template>

<script>
import { doughnutChart } from "@/components/Charts/Chart.js";

export default {
  name: "DoughnutChart",
  props: {
    statusFilter: {
      type: String,
      default: null
    },
    deviceCounts: {
      type: Object,
      default: () => ({
        Secure: 5,
        Warning: 2, 
        Critical: 1
      })
    }
  },
  data() {
    return {
      chart: null
    };
  },
  computed: {
    chartData() {
      return {
        labels: ["Secure", "Warning", "Critical"],
        datasets: [{
          data: [
            this.deviceCounts.Secure || 0,
            this.deviceCounts.Warning || 0,
            this.deviceCounts.Critical || 0
          ],
          backgroundColor: [
            "#4CAF50",  // Green for Secure
            "#FFC107",  // Yellow for Warning
            "#F44336",  // Red for Critical
          ],
          borderWidth: 0
        }]
      };
    }
  },
  watch: {
    deviceCounts: {
      handler() {
        this.updateChart();
      },
      deep: true
    },
    statusFilter() {
      this.updateChart();
    }
  },
  methods: {
    updateChart() {
      if (this.chart) {
        this.chart.data = this.chartData;
        this.chart.update();
      }
    }
  },
  mounted() {
    // Create chart with options
    this.chart = doughnutChart.createChart(
      "doughnut-chart", 
      this.chartData
    );
    
    // Apply custom tooltip option
    if (this.chart) {
      this.chart.options.plugins.tooltip = {
        callbacks: {
          label: (tooltipItem) => {
            const value = this.chartData.datasets[0].data[tooltipItem.dataIndex];
            const label = this.chartData.labels[tooltipItem.dataIndex];
            const total = this.chartData.datasets[0].data.reduce((a, b) => a + b, 0);
            const percentage = total ? Math.round((value / total) * 100) : 0;
            return `${label}: ${value} devices (${percentage}%)`;
          }
        }
      };
      this.chart.update();
    }
    
    // Add click handler for filtering
    this.chart.canvas.addEventListener('click', (evt) => {
      const points = this.chart.getElementsAtEventForMode(evt, 'nearest', { intersect: true }, true);
      if (points.length) {
        const firstPoint = points[0];
        const label = this.chart.data.labels[firstPoint.index];
        this.$emit('filter-status', label);
      }
    });
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  }
};
</script>

<style scoped>
.chart-container {
  margin: auto;
  height: 170px;
}

canvas {
  margin: auto;
}
</style> 